module.exports = __webpack_public_path__ + "static/media/ic-decrease-red.573f7bfb.svg";